import React, { useEffect, useState } from "react";
import "../../assets/css/homepage.css";
import LOGO from "../../assets/img/logopurplenavbar.png";
import INFO from "../../assets/img/placeholderImage2.png";
import BEE from "../../assets/img/placeholderImage3.png";
import DISCOURSE from "../../assets/img/df.png";
import IMG1 from "../../assets/img/gplay.png";
import IMG2 from "../../assets/img/217.png";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Tooltip,
  Typography,
} from "@mui/material";
import France from "../../assets/img/placeholderset1.webp";
import students from "../../assets/img/placeholderset2.jpg";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MailIcon from "@mui/icons-material/Mail";
import AppsIcon from "@mui/icons-material/Apps";
import FullScreenWords from "../newplayer/FullScreenWords2";
import UsersGraph from "../UsersGraph";
//import Categories from "../WordPacksNew";
import IMG from "../../assets/img/des.png";
import {
  ArrowUpward,
  Facebook,
  Instagram,
  LinkedIn,
  Pinterest,
  Twitter,
  YouTube,
} from "@mui/icons-material";
import NewContent from "../NewContent";
import ImageSlider from "../statistics/ImageSlider";
import BeeBanner from "../BeeBanner";

const LandingPage = () => {
  const [position, setPosition] = useState({ top: 50, left: 50 });
  const [highlightedFreePacks, setHighlightedFreePacks] = useState(false);
  const [highlightedPurchasePacks, setHighlightedPurchasePacks] =
    useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isContentLoaded, setIsContentLoaded] = useState(false);

  useEffect(() => {
    const loaderTimeout = setTimeout(() => {
      if (!isContentLoaded) {
        setShowLoader(true);
      }
    }, 301);

    return () => clearTimeout(loaderTimeout);
  }, [isContentLoaded]);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  if (showLoader && !isContentLoaded) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="homepage-container">
      {/* <header id="home" className="hero-section">
        <FullScreenWords />

        <div className="hero-content">
          <div
            className="custom-shape-divider-bottom-1732806073"
            // style={{ position: "relative" }}
          >
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
          <img src={IMG} alt="Logo" className="responsive-logo" />
        </div>
      </header> */}

      <section className="info-section" id="about">
        <div className="infor-container">
          
          <div id="slider" style={{marginTop:'100px'}}>
            <BeeBanner/>
            <ImageSlider />
          </div>

         
          {/* <div className="row-landing">
            <div className="col">
              <h1>Master Words. Change Worlds!</h1>
              <p className="champions-description">
                With purchase of any yearly package priced above $100, get 30{" "}
                minutes consultation with Spelling champions and record holders.
              </p>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <p style={{ marginRight: "10px" }}>
                  <a
                    href="#freepack"
                    onClick={() => {
                      setHighlightedFreePacks(true);
                      setHighlightedPurchasePacks(false);
                    }}
                    className="button"
                  >
                    <i className="fa fa-th"></i> Try Now
                  </a>
                </p>
                <p style={{ marginRight: "10px" }}>
                  <a
                    href="#notfreepack"
                    onClick={() => {
                      setHighlightedPurchasePacks(true);
                      setHighlightedFreePacks(false);
                    }}
                    className="button"
                  >
                    <i className="fa fa-th"></i> Purchase Now
                  </a>
                </p>
                <p>
                  <a href="/comingsoon" className="button">
                    <i className="fa fa-th"></i> Fun Zone
                  </a>
                </p>
              </div>
            </div>
            <div className="col image-container">
              <UsersGraph />
            </div>
          </div> */}
        </div>
        {/* <div className="custom-shape-divider-bottom-1732808109">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              className="shape-fill"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              className="shape-fill"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="shape-fill"
            ></path>
          </svg>
        </div> */}
      </section>

      <section className="champions-section" id="alldata">
        
          <div className="champions-row">
            <NewContent
              highlightedFreePacks={highlightedFreePacks}
              highlightedPurchasePacks={highlightedPurchasePacks}
              onDataLoaded={() => setIsContentLoaded(true)}
            />
          </div>
        
        {/* <div className="champions-shape-divider">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              className="champions-shape-fill"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              className="champions-shape-fill"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="champions-shape-fill"
            ></path>
          </svg>
        </div> */}
      </section>

      {/* Explore Spelling Sets */}
      {/* <section className="explore-section">
        <h2 style={{ textAlign: "center", padding: "30px" }}>
          Explore Spelling Sets
        </h2>
        <h4 style={{ textAlign: "center", padding: "20px" }}>Popular Picks</h4>
        <div className="sets-container">
          <div className="set-card">
            <Card sx={{ maxWidth: 300 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="250"
                  image={France}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    France
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    This category provides familiarity with the various nuances
                    and behaviors of words derived from the French language.
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="set-card">
            <Card sx={{ maxWidth: 300 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="250"
                  image={students}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    SAT Words
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    text
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
          <div className="set-card">
            <Card sx={{ maxWidth: 300 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="250"
                  image={students}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Text
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    text
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        </div>
      </section> */}
      {/* 
      <section className="pricing-section">
        <div className="custom-shape-divider-top">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M649.97 0L550.03 0 599.91 54.12 649.97 0z"
              className="shape-fill2"
            ></path>
          </svg>
        </div>


        <div className="pricing-container" id="pricing">
          <h3>PRICING</h3>
          <p className="pricing-subtitle">
            Choose a package to boost your student's spelling journey.
          </p>


          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header black-bg">Package 1</div>
              <ul className="pricing-details">
                <li>
                  <b>10,000</b> Words
                </li>
                <li>1 on 1 Support</li>
                <li>
                  <b>100</b> Sets
                </li>
                <li>
                  <b>Endless</b> Practice!
                </li>
                <li className="price">
                  <h2>$ 499</h2>
                  <span>per year</span>
                </li>
                <li className="pricing-footer">
                  <button className="signup-button">Sign Up</button>
                </li>
              </ul>
            </div>

            <div className="pricing-card">
              <div className="pricing-header purple-bg">Package 2</div>
              <ul className="pricing-details">
                <li>
                  <b>10,000</b> Words
                </li>
                <li>1 on 1 Support</li>
                <li>
                  <b>100</b> Sets
                </li>
                <li>
                  <b>Endless</b> Practice!
                </li>
                <li className="price">
                  <h2>$ 499</h2>
                  <span>per year</span>
                </li>
                <li className="pricing-footer">
                  <button className="signup-button">Sign Up</button>
                </li>
              </ul>
            </div>

            <div className="pricing-card">
              <div className="pricing-header black-bg">Package 3</div>
              <ul className="pricing-details">
                <li>
                  <b>10,000</b> Words
                </li>
                <li>1 on 1 Support</li>
                <li>
                  <b>100</b> Sets
                </li>
                <li>
                  <b>Endless</b> Practice!
                </li>
                <li className="price">
                  <h2>$ 499</h2>
                  <span>per year</span>
                </li>
                <li className="pricing-footer">
                  <button className="signup-button">Sign Up</button>
                </li>
              </ul>
            </div>
            <div class="button-container">
              <button class="pricing-button">
                <div class="line one">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line two">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line three">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line four">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line five">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line six">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
                <div class="line seven">
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                  <div class="round"></div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section> */}

      {/* <div className="contact-container" id="contact">
        <h3 className="contact-title">CONTACT</h3>
        <p className="contact-subtitle">
          Questions? Send us a message or give us a call:
        </p>
        <div className="contact-details">
          <p>
            <i className="fa fa-map-marker contact-icon"></i> Chicago, US
          </p>
          <p>
            <i className="fa fa-phone contact-icon"></i> Phone: +1 (512)
            229-7106
          </p>
        </div>
      </div> */}

      {/* Footer */}
      {/* <footer className="footer">
        <a href="#home" className="to-top-btn">
          <i className="fa fa-arrow-up"></i> To the top
        </a>
        <div className="social-icons">
          <i className="fa fa-facebook-official"></i>
          <i className="fa fa-instagram"></i>
          <i className="fa fa-snapchat"></i>
          <i className="fa fa-pinterest-p"></i>
          <i className="fa fa-twitter"></i>
          <i className="fa fa-linkedin"></i>
        </div>
      </footer> */}
      {/* <VideoRecorder/> */}

      <footer className="footer">
        <a
          href="#top"
          className={`to-top-btn ${isVisible ? "show" : "hide"}`}
          onClick={scrollToTop}
        >
          <ArrowUpward />
        </a>

        <div className="social-icons">
          <a href="https://www.facebook.com/S3NSoftware" target="_blank">
            <Facebook fontSize="small" />
          </a>
          <a href="https://www.instagram.com/S3NSoftware" target="_blank">
            <Instagram fontSize="small" />
          </a>
          <a href="https://twitter.com/s3n_sw" target="_blank">
            <Twitter fontSize="small" />
          </a>
          <a
            href="https://www.youtube.com/channel/UC8_afJBgKQXJRPX7S2rQ2Ug"
            target="_blank"
          >
            <YouTube fontSize="small" />
          </a>
          <a
            href="https://myspelling-app.com"
            className="discourse-forum"
            target="_blank"
          >
            <Tooltip title="Discourse Forums" arrow>
              <img
                src={DISCOURSE}
                alt="discourse forums"
                style={{ height: "30px", width: "30px" }}
              />
            </Tooltip>
          </a>
        </div>
        {/* <div className="social-icons">
          <a
            href="https://play.google.com/store/apps/details?id=com.infinixinfojnr.spellapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={IMG1} className="play-store" alt="Play Store Link 1" />
          </a>
          <a
            href="https://apps.apple.com/in/app/spelling/id1645735084"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={IMG2} className="play-store" alt="Play Store Link 2" />
          </a>
        </div> */}
      </footer>
    </div>
  );
};

export default LandingPage;
